<button
  (click)="click()"
  [type]="btnType"
  [disabled]="isDisabled"
  [title]="label"
  class="inline-flex relative items-center font-medium border border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2"
  [tabindex]="isDisabled ? '-1' : ''"
  [ngClass]="[
    size === 'xs' ? ' px-2.5 py-1.5 text-xs' : '',
    size === 'base' ? 'px-4 py-2 text-sm' : '',
    size === 'xl' ? 'px-6 py-3 text-base' : '',
    type === 'primary' ? 'text-white bg-monza-500 hover:bg-monza-600 focus:ring-monza-400' : '',
    type === 'secondary' ? 'text-white bg-emerald-500 hover:bg-emerald-600 focus:ring-emerald-400' : '',
    type === 'tertiary' ? 'text-white bg-purple-500 hover:bg-purple-600 focus:ring-purple-400' : '',
    type === 'socket' ? 'text-white bg-yellow-500 hover:bg-yellow-600 focus:ring-yellow-400' : '',
    type === 'wall' ? 'text-white bg-orange-500 hover:bg-orange-600 focus:ring-orange-400' : '',
    type === 'light' ? 'text-gray-500 bg-white hover:bg-gray-50 focus:ring-gray-400 border-gray-300' : '',
    type === 'ghost' ? 'text-gray-900 bg-transparent hover:bg-gray-100 focus:ring-gray-400 shadow-none' : '',
    type === 'outline-primary'
      ? 'text-gray-500 bg-white hover:border-monza-500 hover:text-monza-500 focus:ring-monza-400 border-monza-300'
      : '',
    type === 'outline-secondary'
      ? 'text-gray-500 bg-white hover:border-amber-500 hover:text-amber-500 focus:ring-amber-400 border-amber-300'
      : '',
    fullWidth ? 'w-full justify-center' : '',
    isDisabled ? 'opacity-50 pointer-events-none' : ''
  ]"
>
  <ng-container *ngIf="!customContent">
    <app-icon
      [ngClass]="[
        size === 'xs' ? 'hidden' : '',
        size === 'base' ? '-ml-1 mr-2 h-5 w-5' : '',
        size === 'xl' ? '-ml-1 mr-3 h-5 w-5' : '',
        onlyIcon && size === 'base' ? 'h-5 w-5 -mr-2 -ml-2' : '',
        onlyIcon && size === 'xs' ? 'h-5 w-5 -mr-1 -ml-1' : '',
        loading ? 'opacity-0' : 'opacity-100',
        isIconRotated ? '-rotate-90' : ''
      ]"
      *ngIf="icon"
      [icon]="icon"
      class="transition-all duration-500"
    ></app-icon>
    <div role="status" *ngIf="loading">
      <svg
        aria-hidden="true"
        [ngClass]="{
          'left-2': size === 'xs',
          'left-3': size === 'base',
          'left-4': size === 'xl',
          'fill-monza-600': type === 'primary',
          'fill-emerald-400': type === 'secondary'
        }"
        class="absolute top-2 transition-opacity duration-500 text-gray-200 animate-spin dark:text-gray-600 h-5 w-5"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        />
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        />
      </svg>
      <span class="sr-only">Loading...</span>
    </div>
    <span *ngIf="!onlyIcon">{{ label }} </span>
  </ng-container>
  <ng-content *ngIf="customContent"></ng-content>
</button>
<span
  *ngIf="!onlyIcon && showPrice && price !== undefined"
  [ngClass]="[
    size === 'xs' ? ' px-2 py-1.5 text-xs' : '',
    size === 'base' ? 'px-3 py-2 text-sm' : '',
    size === 'xl' ? 'px-4 py-3 text-base' : '',
    price > 0 ? 'bg-amber-100 border-amber-100 text-amber-800' : '',
    price < 0 ? 'bg-green-100 border-green-100 text-green-800' : '',
    price === 0 ? 'bg-purple-100 border-purple-100 text-purple-800' : ''
  ]"
  class="font-medium border whitespace-nowrap inline-flex relative items-center border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2"
  >{{ price > 0 ? '+' : '' }}{{ price }} CHF</span
>
